module.exports = __webpack_public_path__ + "assets/img/26_1536.1ed5432c.jpg";